/* eslint-disable react/button-has-type */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable comma-dangle */
/* eslint-disable no-confusing-arrow */
/* eslint-disable object-curly-newline */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MdFlag } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';

import history from '~/services/history';
import Mobile from '~/components/Mobile';

import api from '~/services/api';
import {
  Header,
  Body,
  CloseModal,
  Modal,
  ViewToolTip,
  ViewToolTipChallenge,
} from './styles';

import Iniciante from '~/assets/images/Iniciante.png';
import Intermediario from '~/assets/images/Intermediario.png';
import Basico from '~/assets/images/Basico.png';
import Avancado from '~/assets/images/Avancado.png';
import Master from '~/assets/images/Master.png';
import Letter from '~/assets/images/logoLetter.png';
import Acerto from '~/assets/images/acerto.png';
import Revisao from '~/assets/images/revisao.png';
import Erro from '~/assets/images/erro.png';

const image = [
  {
    img: Letter,
    level: 'Níveis Apollo',
    challenges: 'Desafios Validados',
    projects: 'Certificado de Projetos',
    apollo: 'Certificado Mentalidade Apollo',
    tutor: 'Tutoria',
    apollojr: 'Trabalhos na Apollo Jr.',
  },
  {
    img: Iniciante,
    level: 'INICIANTE',
    challenges: 'Nenhum',
    // projects: 'Nenhum',
    // apollo: 'Nenhum',
    // tutor: 'Tutoria',
    apollojr: 'Nenhum',
  },
  {
    img: Basico,
    level: 'BÁSICO',
    challenges: '50 Geral',
    // projects: '1',
    // apollo: 'Básico',
    // tutor: '1 mês ',
    apollojr: 'Nenhum',
  },
  {
    img: Intermediario,
    level: 'INTERMEDIÁRIO',
    challenges: '100 Geral',
    // projects: '2',
    // apollo: 'Intermediário',
    // tutor: '5 meses ',
    apollojr: '1',
  },
  {
    img: Avancado,
    level: 'AVANÇADO',
    challenges: '100 Geral +  50 Avançado',
    // projects: '3',
    // apollo: 'Avançado',
    // tutor: '5 meses ',
    apollojr: '2',
  },
  {
    img: Master,
    level: 'MASTER',
    challenges: '150 Geral + 50 Master',
    // projects: '5',
    // apollo: 'Master',
    // tutor: '10 meses ',
    apollojr: '3',
  },
];

export default function Conquer() {
  const user = useSelector((state) => state.user.profile);
  const token = useSelector((state) => state.auth.token.token);
  const [modules, setModules] = useState([]);
  const [scorecard, setScorecard] = useState('');
  const [modal, setModal] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [level, setLevel] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);
    api.defaults.headers.Authorization = `Bearer ${token}`;
    async function getData() {
      const { data } = await api.get(`/achievements/${user.id}`);

      setModules(data);
    }

    async function getDataScorecard() {
      const { data } = await api.get(`students/${user.id}/scorecards`);

      setScorecard(data);
    }

    async function getDataJobs() {
      const { data } = await api.get('applies');
      setJobs(data);
    }

    getData();
    getDataScorecard();
    getDataJobs();
  }, [token, user]);

  useEffect(() => {
    async function getLevel() {
      const { data } = await api.get(`/users/${user.id}`);
      setLevel(data.apollo_level);
    }
    getLevel();
  }, [user]);

  function toggleModal() {
    return modal === false ? setModal(true) : setModal(false);
  }

  const isMobile = useMediaQuery({
    query: '(max-width: 500px)',
  });

  return (
    <>
      {isMobile ? (
        <Mobile />
      ) : (
        <>
          {modal === true ? (
            <CloseModal onClick={toggleModal}>
              <Modal>
                <h1>Veja como funciona os Níveis Apollo</h1>
                <div className="support">
                  <table>
                    <tr>
                      {image.map((item) => (
                        <th
                          style={{
                            borderBottomColor: '#fff',
                          }}
                          key={item.id}
                        >
                          <img src={`${item.img}`} alt="levels" />{' '}
                        </th>
                      ))}
                    </tr>
                    <tr>
                      {image.map((item) => (
                        <td
                          style={{
                            height: 40,
                            fontWeight: 'bold',
                            borderTopColor: '#fff',
                          }}
                        >
                          {item.level}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      {image.map((item) => (
                        <td key={item.id}>{item.challenges}</td>
                      ))}
                    </tr>
                    {/* <tr>
                  {image.map((item) => (
                    <td>{item.projects}</td>
                  ))}
                </tr>
                <tr>
                  {image.map((item) => (
                    <td style={{ fontSize: 16 }}>{item.apollo}</td>
                  ))}
                </tr>
                <tr>
                  {image.map((item) => (
                    <td style={{ fontSize: 16 }}>{item.tutor}</td>
                  ))}
                </tr> */}
                    <tr>
                      {image.map((item) => (
                        <td style={{ fontSize: 16 }} key={item.id}>
                          {item.apollojr}
                        </td>
                      ))}
                    </tr>
                  </table>
                </div>
                <h2>
                  Quanto maior o seu nível, mais vagas e oportunidades você tem
                  na Apollo.
                </h2>
              </Modal>
            </CloseModal>
          ) : null}

          <h1 style={{ color: '#36ded6', marginLeft: 30, paddingTop: 30 }}>
            Dashboard
          </h1>

          <Header>
            <div className="apollo">
              <p>
                NÍVEL APOLLO{' '}
                {/* <MdInfoOutline
              size={20}
              color="#fff"
              style={{ marginBottom: -5, cursor: 'pointer' }}
              onClick={toggleModal}
            /> */}
              </p>
              <button className="levels" id="apolloLevel" onClick={toggleModal}>
                <div className="support">
                  {level ? (
                    <>
                      <img src={`${image[level].img}`} alt="apollo" />
                      <p style={{ marginTop: 10 }}>{image[level].level}</p>
                    </>
                  ) : null}
                </div>
              </button>
              <UncontrolledTooltip
                delay={0}
                placement="right-start"
                target="apolloLevel"
              >
                <ViewToolTip>
                  <p style={{ fontWeight: 'bold' }}>Nível Apollo</p>
                  <p>Clique para saber mais.</p>
                </ViewToolTip>
              </UncontrolledTooltip>
            </div>
            <div className="challenges">
              <Link to="/scorecard">
                <p
                  style={{
                    color: '#fff',
                    marginLeft: 14,
                    marginTop: 50,
                    marginBottom: 5,
                  }}
                >
                  STATUS DOS DESAFIOS
                </p>
              </Link>
              <div className="support-scorecard">
                <Link to="/scorecard" style={{ color: '#fff' }}>
                  <div className="scorecard" id="challenges">
                    <div className="flag">
                      <MdFlag size={30} color="#fff" />
                      <h1 style={{ marginLeft: 10 }}>STATUS</h1>
                    </div>
                  </div>
                </Link>
                <div className="detail" style={{ marginLeft: 30 }}>
                  <div className="image">
                    <img src={Acerto} alt="acerto.png" />
                  </div>
                  <div className="subDetail">
                    <div className="n">
                      <p className="number"> {scorecard.correct}</p>
                      <div>
                        <p style={{ fontSize: 14 }}>STATUS</p>
                        <p style={{ color: '#fff' }}>ACERTOS</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detail">
                  <div className="image">
                    <img src={Revisao} alt="revisao.png" />
                  </div>
                  <div className="subDetail">
                    <div className="n">
                      <p className="number"> {scorecard.processing}</p>
                      <div>
                        <p style={{ fontSize: 14 }}>STATUS</p>
                        <p style={{ color: '#fff' }}>REVISĀO</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="detail">
                  <div className="image">
                    <img src={Erro} alt="erro.png" />
                  </div>
                  <div className="subDetail">
                    <div className="n">
                      <p className="number"> {scorecard.wrong}</p>
                      <div>
                        <p style={{ fontSize: 14 }}>STATUS</p>
                        <p style={{ color: '#fff' }}>ERROS</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <UncontrolledTooltip
              delay={0}
              placement="left-start"
              target="challenges"
            >
              <ViewToolTipChallenge>
                <p style={{ fontWeight: 'bold' }}>Status dos seus Desafios</p>
                <p>Clique para saber mais.</p>
              </ViewToolTipChallenge>
            </UncontrolledTooltip>
          </Header>

          <Body>
            <div className="jobs">
              <p>VAGAS APLICADAS</p>
              {jobs.length >= 1 ? (
                <>
                  {' '}
                  <p style={{ marginTop: 20 }}>Aprovado para Entrevista:</p>
                  <div className="support1">
                    {jobs.map((job) =>
                      job.status === 'approved' ? (
                        <Link
                          to={`/jobfeedback/${job.id}`}
                          style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
                          key={job.id}
                        >
                          <div className="approved">
                            <img src={`${job.job.file.url}`} alt="company" />
                            <div>
                              {/* <p>{job.job.company}</p> */}
                              <p>{job.job.title}</p>
                              <p style={{ fontSize: 12 }}>{job.job.local}</p>
                            </div>
                          </div>
                        </Link>
                      ) : null
                    )}
                  </div>
                  <p style={{ marginTop: 20 }}>Em Análise:</p>
                  <div className="support1">
                    {jobs.map((job) =>
                      job.status === 'processing' ? (
                        <Link
                          to={`/jobfeedback/${job.id}`}
                          style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
                        >
                          <div className="approved">
                            <img src={`${job.job.file.url}`} alt="company" />
                            <div>
                              {/* <p>{job.job.company}</p> */}
                              <p>{job.job.title}</p>
                              <p style={{ fontSize: 12 }}>{job.job.local}</p>
                            </div>
                          </div>
                        </Link>
                      ) : null
                    )}
                  </div>
                  <p style={{ marginTop: 20 }}>
                    Vagas Nāo aprovadas (clique nos cards para saber o motivo):
                  </p>
                  <div className="support1">
                    {jobs.map((job) =>
                      job.status === 'denied' ? (
                        <Link
                          to={`/jobfeedback/${job.id}`}
                          key={job.id}
                          style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
                        >
                          <div className="approved">
                            <img src={`${job.job.file.url}`} alt="company" />
                            <div>
                              {/* <p>{job.job.company}</p> */}
                              <p>{job.job.title}</p>
                              <p style={{ fontSize: 12 }}>{job.job.local}</p>
                            </div>
                          </div>
                        </Link>
                      ) : null
                    )}
                  </div>
                </>
              ) : (
                <div className="noModules">
                  <p style={{ marginTop: 20, fontSize: 18 }}>
                    Você ainda nāo se aplicou pra nehuma vaga.
                  </p>
                  <p style={{ marginTop: 5, fontSize: 14 }}>
                    Clique no botāo abaixo para ir para Vagas:
                  </p>
                  <button type="submit" onClick={() => history.push('/mail')}>
                    VER VAGAS
                  </button>
                </div>
              )}
            </div>
            <div className="modules">
              <p style={{ color: '#fff' }}>CONQUISTAS</p>
              {modules.length >= 1 ? (
                <div className="supportCards">
                  {modules.map((module) => {
                    const newTitle = module.module.title.split('- ', 4);
                    return (
                      <Link
                        to={`/playground/${module.module.id}`}
                        key={module.module.id}
                        style={{ backgroundColor: 'rgba(0,0,0,0.2)' }}
                      >
                        <div className="card">
                          <img src={`${module.module.file.url}`} alt="card" />

                          <p style={{ marginTop: 1 }}>{newTitle[2]}</p>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              ) : (
                <div className="noModules">
                  <p style={{ marginTop: 20, fontSize: 18 }}>
                    Você ainda nāo possui nenhuma conquista.
                  </p>
                  <p style={{ marginTop: 5, fontSize: 14 }}>
                    Clique no botāo abaixo para ir para os Módulos:
                  </p>
                  <button
                    type="submit"
                    onClick={() => history.push('/subjects')}
                  >
                    VER DESAFIOS
                  </button>
                </div>
              )}
            </div>
          </Body>
        </>
      )}
    </>
  );
}
